import { useState, useEffect, useRef, useContext } from "react";
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

// import useAxios from "../../components/useAxios";
import authAxios from "../../components/authAxios";

import { useNavigate, useLocation } from "react-router-dom";
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";

import { Modal } from 'antd';
import { message } from 'antd';


import NumberFormat from "react-number-format";
import {UserContext} from "../../App"
import UserAlerts from "../../components/UserAlerts";
// import DashboardHeader from "../../components/DashboardHeader";
import Loading from "../../components/Loading";

import './Rentals.css'


function UnitEdit({unit, isModalOpen, setIsModalOpen}) {

    // const {response, error, fetchData}  = useAxios();
    const [error, setError] = useState('');
    const errorRef = useRef(null);


    const queryClient = useQueryClient();

    const page_size = useContext(UserContext).page_size;

    const user = localStorage.getItem('userID');
    const client = localStorage.getItem('clientID');


    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const [reference, setReference] = useState('');
    // const [reference, setReference] = useState(unit.reference);
    const [referenceError, setReferenceError] = useState(false);

    const contactRef = useRef("");
    contactRef.showContactType=true    


    const mutation = useMutation({
        mutationFn: (unitData) => {
            return authAxios.put(`rentals/property-units/${unit.id}/`, unitData);
        },
        onError: (error, variables, context) => {
            if (error.response.data.error){
                // If it's an array, display each error message
                if (Array.isArray(error.response.data.error)) {
                    error.response.data.error.map((errorMessage) => (
                        setError(errorMessage)
                    ));
                } else {
                    // Handle single error message
                    setError(error.response.data.error); 
                }
            } else {
                // Fallback to Standard error message
                setError(error.message); 
            }      
        },
        onSuccess: (result) => {
            message.success('Unit updated successfully');
            queryClient.invalidateQueries(['property-units', 'property-unit']);
            queryClient.refetchQueries(['property-units']);
            queryClient.refetchQueries(['property-unit']);
            setIsModalOpen(false)
        },
    })


    const handleSubmit = (e) => {
        e.preventDefault();

        if (reference === '') {
            setReferenceError(true)
        }

        if (reference ) {
            const unitData = {reference };
            console.log(unitData)
            mutation.mutate(unitData)
            
        } 
    
    }

    useEffect(()=>{   
        if (unit){
            setReference(unit.reference)
        }
    },[unit])

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])

    // if (!unit) return <Loading loading={true} />;

    return(
        <>
        {isModalOpen && unit &&
            <Modal className="dashboard-modal" title="Edit Unit" visible={isModalOpen} open={isModalOpen} onOk={handleSubmit} onCancel={handleCancel}>
                <div className="dashboard-form">

                    <div ref={errorRef}>
                        <UserAlerts error={error}  />
                    </div>

                    <form noValidate autoComplete="off" onSubmit={handleSubmit}>

                        <TextField className="custom-input"
                            // value={propertyName}   
                            value={unit?.property_name}
                            label="Property" 
                            variant="outlined" 
                            fullWidth
                            disabled
                            InputProps={{ readOnly: true }}
                        />

                        {unit && unit.lease? (
                            <TextField className="custom-input"
                                value={unit.lease?.customer_name || ''}
                                label="Tenant" 
                                variant="outlined" 
                                fullWidth
                                disabled
                                InputProps={{ readOnly: true }}
                            />
                        )
                        :
                        (
                            <TextField className="custom-input"
                                value={unit.status_name || ''}
                                label="Status" 
                                variant="outlined" 
                                fullWidth
                                disabled
                                InputProps={{ readOnly: true }}
                            />
                        )}

                        <TextField className="custom-input"
                            value={reference}
                            onChange={(e) => {
                                setReferenceError(false)
                                setReference(e.target.value)
                            }}
                            label="Reference" 
                            variant="outlined" 
                            fullWidth
                            required
                            error={referenceError}
                        />  
                    </form>
                </div>
            </Modal>
        }
        </>

    )

}

export default UnitEdit;
